export default __webpack_public_path__ + "static/media/atsuya-logo-name.d11a5a20.svg";